module.exports = __webpack_public_path__ + "static/NotoSans-Bold.subset-e30c27b488229bc905ac1b26988ad7d3.woff";